import React from "react";

const LoadCube: React.FC = () => (
    <div className="cssload-thecube">
        <div className="cssload-cube cssload-c1"></div>
        <div className="cssload-cube cssload-c2"></div>
        <div className="cssload-cube cssload-c4"></div>
        <div className="cssload-cube cssload-c3"></div>
    </div>
);

const Loading: React.FC = () => (
    <div>
        <h1>Vent litt...</h1>
        <LoadCube />
    </div>
);

export default Loading;
